import Component, { mixins } from "vue-class-component";
import MyMixin from "@/mixins/datemixin";
@Component
export default class EcartBOFOMixin extends mixins(MyMixin) {
  public montantTicketsBO = {
    ht: 0,
    ttc: 0,
    payByFamille: {},
    regl: 0,
    nbr: 0,
  };
  public recusData: { [key: string]: any } = {};
  public validated = false;
  public validationData = {
    validated: false,
    site: 0,
    ecart: 0,
    tickets: 0,
    recus: 0,
    synthese: 0,
  };

  public analyseTicketsFO(tickets: any) {
    this.montantTicketsBO.ttc = 0;
    this.montantTicketsBO.ht = 0;
    this.montantTicketsBO.nbr = 0;
    this.montantTicketsBO.regl = 0;
    for (const ticket of tickets) {
      if (ticket.invoice.paid) {
        this.montantTicketsBO.ttc += parseFloat(ticket.invoice.totalNetTTC);
        this.montantTicketsBO.ht += parseFloat(ticket.invoice.totalNetHT);
        this.montantTicketsBO.nbr++;

        ticket.invoice.payments.map((pay: any) => {
          this.montantTicketsBO.regl += pay.amount;
        });
      }
    }
    this.validationData.tickets = this.montantTicketsBO.ht;
  }

  public analyseRecus(recus: any) {
    this.recusData.montantRecus = 0;
    this.recusData.montantAnomalies = 0;
    this.recusData.montantRecusReel = 0;
    this.recusData.bons = new Array();
    for (const reglement of recus.reglements) {
      if (reglement.libelle !== "REPAS EMPLOYE") {
        this.recusData.montantRecus += parseFloat(reglement.totalTheorique);
        this.recusData.montantAnomalies += parseFloat(reglement.ecart);
        this.recusData.montantRecusReel += parseFloat(reglement.totalReel);
      }
    }
    this.validationData.recus = this.recusData.montantRecus;
    this.calculateReglFam(recus.reglements);
    for (const bon of recus.bons) {
      this.recusData.bons.push(bon);
    }
  }

  public analyseAllSites(site: any, listeResto: any) {
    const monsite = listeResto.filter((si: any) => {
      // console.log(si.bkNumber + "" === site);
      return si.bkNumber + "" === site;
    });
    // console.log(monsite);
    this.validationData.tickets = this.montantTicketsBO.ht;
    this.validationData.synthese = monsite[0].caHT;
    this.validationData.site = site;
    if (monsite.length === 1) {
      this.validationData.validated =
        this.validationData.tickets.toFixed(2) ===
        this.validationData.synthese.toFixed(2);
      console.log(site, this.validationData);
    }
  }
  /**
   * methode de calcul des reglement par famille
   * @param reglements les reglements à grouper par famille
   */
  public calculateReglFam(reglements: any) {
    const payObj: any = {};
    reglements.map((regl: any) => {
      if (payObj[regl.libelleFamille] !== undefined) {
        payObj[regl.libelleFamille] += regl.totalReel;
      } else {
        payObj[regl.libelleFamille] = regl.totalReel;
      }
    });
    // console.log(payObj);
    this.recusData.reglements = payObj;
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
